export default function RestrictedAccess() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50 p-6">
            <div className="bg-white shadow-md rounded-lg p-8 max-w-lg text-center border border-gray-200 relative -mt-20">
                {/* Error Icon */}
                <div className="flex justify-center mb-4">
                    <svg
                        className="w-12 h-12 text-red-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                </div>

                <h2 className="text-xl font-semibold text-gray-800 mb-3">
                    Restricted Access
                </h2>
                <p className="text-gray-600">
                    This page is available only for{" "}
                    <span className="font-medium text-[#006aa9]">
                        Business Purpose Loans
                    </span>
                </p>
            </div>
        </div>
    );
}